export interface SearchPage<T> {
  results: T[];
  count: number;
}
